import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FcConferenceCall, FcPlanner, FcEngineering, FcCheckmark } from "react-icons/fc";
import "./ProcessSection.css";

const ProcessSection = () => {
  const processSteps = [
    {
      step: "1",
      title: "Consultation",
      icon: <FcConferenceCall size={50} />,
      desc: "We discuss your ideas, requirements, and budget in detail. Understanding your vision helps us create a personalized plan that matches your expectations."
    },
    {
      step: "2",
      title: "Planning",
      icon: <FcPlanner size={50} />,
      desc: "Our team creates a detailed renovation plan, including design layouts, material selection, and timeline. Every detail is considered to ensure a smooth process."
    },
    {
      step: "3",
      title: "Execution",
      icon: <FcEngineering size={50} />,
      desc: "We bring your plan to life with skilled professionals and precise execution. Quality workmanship and attention to detail are our top priorities."
    },
    {
      step: "4",
      title: "Completion",
      icon: <FcCheckmark size={50} />,
      desc: "We complete the project on time, ensuring everything is polished and functional. You receive a ready-to-use space with quality assurance."
    },
  ];

  return (
    <section id="process" className="process-section py-5 text-center">
      <Container>
        <h2 className="fw-bold mb-5">Our Process</h2>
        <Row className="g-4">
          {processSteps.map((item, index) => (
            <Col key={index} xs={12} sm={6} xl={3}>
              <Card className="process-card h-100 border-0 text-center">
                <Card.Body>
                  <div className="process-icon mb-3">{item.icon}</div>
                  <h3 className="text-primary mb-2">{item.step}</h3>
                  <Card.Title className="fw-semibold">{item.title}</Card.Title>
                  <Card.Text>{item.desc}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ProcessSection;
